import { render, staticRenderFns } from "./Laboratorios.vue?vue&type=template&id=bb6c06b6&scoped=true"
import script from "./Laboratorios.vue?vue&type=script&lang=js"
export * from "./Laboratorios.vue?vue&type=script&lang=js"
import style0 from "./Laboratorios.vue?vue&type=style&index=0&id=bb6c06b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6c06b6",
  null
  
)

export default component.exports